import React, { useEffect, useState, useCallback, useMemo } from 'react';
import api from '../services/api';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// --- Sub-componente: Modal para Períodos de Preenchimento ---
const PeriodoModal = ({ periodo, onClose, onSave, grupo }) => {
    const [form, setForm] = useState({
        mes_referencia: '',
        data_inicio: '',
        data_fim: '',
        data_inicio_escala: '',
        data_fim_escala: '',
        cor_ombreira_padrao: ''
    });
    // Lista de meses para o select
    const meses = [
        { value: '01', label: 'Janeiro' },
        { value: '02', label: 'Fevereiro' },
        { value: '03', label: 'Março' },
        { value: '04', label: 'Abril' },
        { value: '05', label: 'Maio' },
        { value: '06', label: 'Junho' },
        { value: '07', label: 'Julho' },
        { value: '08', label: 'Agosto' },
        { value: '09', label: 'Setembro' },
        { value: '10', label: 'Outubro' },
        { value: '11', label: 'Novembro' },
        { value: '12', label: 'Dezembro' },
    ];

    // Lista de cores para coroinha
    const coresPadrao = [
        { nome: 'Branco', valor: '#FFFFFF' },
        { nome: 'Verde', valor: '#008000' },
        { nome: 'Vermelho', valor: '#FF0000' },
        { nome: 'Roxo', valor: '#800080' },
        { nome: 'Preto', valor: '#000000' },
        { nome: 'Roseo', valor: '#FFC0CB' },
    ];
    const [erros, setErros] = useState({});
    useEffect(() => {
        // Sempre usa o ano atual
        const hoje = new Date();
        const anoAtual = String(hoje.getFullYear());
        let mes = '';
        if (periodo?.mes_referencia) {
            [, mes] = periodo.mes_referencia.split('-');
        } else {
            mes = String(hoje.getMonth() + 1).padStart(2, '0');
        }
        setForm({
            mes_referencia: `${anoAtual}-${mes}`,
            data_inicio: periodo?.data_inicio ? new Date(periodo.data_inicio).toISOString().split('T')[0] : '',
            data_fim: periodo?.data_fim ? new Date(periodo.data_fim).toISOString().split('T')[0] : '',
            data_inicio_escala: periodo?.data_inicio_escala ? new Date(periodo.data_inicio_escala).toISOString().split('T')[0] : '',
            data_fim_escala: periodo?.data_fim_escala ? new Date(periodo.data_fim_escala).toISOString().split('T')[0] : '',
            cor_ombreira_padrao: periodo?.cor_ombreira_padrao || ''
        });
        setErros({});
    }, [periodo]);

    const validar = (novoForm = form) => {
        const erros = {};
        if (novoForm.data_inicio && novoForm.data_fim && novoForm.data_fim < novoForm.data_inicio) {
            erros.data_fim = 'A data de fim do preenchimento não pode ser menor que a de início.';
        }
        if (novoForm.data_inicio_escala && novoForm.data_fim_escala && novoForm.data_fim_escala < novoForm.data_inicio_escala) {
            erros.data_fim_escala = 'A data de fim da geração não pode ser menor que a de início.';
        }
        // Mensagem de erro removida conforme solicitado
        return erros;
    };

    const handleChange = (e) => {
        let novoForm = { ...form, [e.target.name]: e.target.value };
        // Se mudou o mês, sempre usa o ano atual
        if (e.target.name === 'mes_referencia') {
            const anoAtual = String(new Date().getFullYear());
            novoForm.mes_referencia = `${anoAtual}-${e.target.value}`;
        }
        setForm(novoForm);
        setErros(validar(novoForm));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const errosValidacao = validar();
        setErros(errosValidacao);
        if (Object.keys(errosValidacao).length > 0) return;
        onSave({ ...periodo, ...form });
    };

    return (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex justify-center items-center z-50 p-4" aria-modal="true" role="dialog">
            <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-lg">
                <h2 className="text-2xl font-bold mb-6">{periodo?.id ? 'Editar Período' : 'Adicionar Novo Período'}</h2>
                <form onSubmit={handleSubmit} className="space-y-4" aria-label="Formulário de período">
                    <div>
                        <label className="block text-sm font-medium text-gray-700" htmlFor="mes_referencia">Mês de Referência</label>
                        <div className="flex gap-2 items-center">
                            <select
                                name="mes_referencia"
                                id="mes_referencia"
                                value={form.mes_referencia.split('-')[1]}
                                onChange={handleChange}
                                className="w-full p-3 border rounded-lg mt-1"
                                required
                                aria-label="Mês de referência"
                                disabled={!!periodo?.id}
                            >
                                {meses.map(m => (
                                    <option key={m.value} value={m.value}>{m.label}</option>
                                ))}
                            </select>
                            <span className="ml-2 text-gray-600 font-semibold select-none">{new Date().getFullYear()}</span>
                        </div>
                    </div>
                    {/* Campo cor padrão para coroinha */}
                    {grupo?.tipo?.toLowerCase() === 'coroinhas' && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700" htmlFor="cor_ombreira_padrao">Cor da Ombreira</label>
                            <div className="relative">
                                <select
                                    name="cor_ombreira_padrao"
                                    id="cor_ombreira_padrao"
                                    value={form.cor_ombreira_padrao}
                                    onChange={handleChange}
                                    className="w-full p-3 border rounded-lg mt-1 appearance-none pr-10"
                                    required
                                    aria-label="Cor da Ombreira"
                                >
                                    <option value="">Selecione uma cor</option>
                                    {coresPadrao.map(cor => (
                                        <option key={cor.valor} value={cor.valor}>
                                            {cor.nome}
                                        </option>
                                    ))}
                                </select>
                                {/* Preview da cor selecionada */}
                                {form.cor_ombreira_padrao && (
                                    <span
                                        className="absolute right-3 top-1/2 transform -translate-y-1/2 w-6 h-6 rounded-full border border-gray-300"
                                        style={{ backgroundColor: form.cor_ombreira_padrao }}
                                        title={coresPadrao.find(c => c.valor === form.cor_ombreira_padrao)?.nome || form.cor_ombreira_padrao}
                                    ></span>
                                )}
                            </div>
                        </div>
                    )}
                    <div>
                        <label className="block text-sm font-medium text-gray-700" htmlFor="data_inicio">Data de Início do Preenchimento</label>
                        <input name="data_inicio" id="data_inicio" value={form.data_inicio} onChange={handleChange} type="date" className="w-full p-3 border rounded-lg mt-1" required aria-label="Data de início do preenchimento" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700" htmlFor="data_fim">Data de Fim do Preenchimento</label>
                        <input name="data_fim" id="data_fim" value={form.data_fim} onChange={handleChange} type="date" className={`w-full p-3 border rounded-lg mt-1 ${erros.data_fim ? 'border-red-500' : ''}`} required aria-label="Data de fim do preenchimento" />
                        {erros.data_fim && <p className="text-red-500 text-xs mt-1" aria-live="assertive">{erros.data_fim}</p>}
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700" htmlFor="data_inicio_escala">Data de Início da Geração da Escala</label>
                        <input name="data_inicio_escala" id="data_inicio_escala" value={form.data_inicio_escala} onChange={handleChange} type="date" className="w-full p-3 border rounded-lg mt-1" required aria-label="Data de início da geração da escala" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700" htmlFor="data_fim_escala">Data de Fim da Geração da Escala</label>
                        <input name="data_fim_escala" id="data_fim_escala" value={form.data_fim_escala} onChange={handleChange} type="date" className={`w-full p-3 border rounded-lg mt-1 ${erros.data_fim_escala ? 'border-red-500' : ''}`} required aria-label="Data de fim da geração da escala" />
                        {erros.data_fim_escala && <p className="text-red-500 text-xs mt-1" aria-live="assertive">{erros.data_fim_escala}</p>}
                    </div>
                    <div className="flex justify-end gap-4 pt-4">
                        <button type="button" onClick={onClose} className="px-5 py-2 bg-gray-200 rounded-lg" aria-label="Cancelar">Cancelar</button>
                        <button type="submit" className="px-5 py-2 bg-blue-600 text-white rounded-lg" disabled={Object.keys(erros).length > 0} aria-label="Salvar período">Salvar</button>
                    </div>
                </form>
            </div>
        </div>
    );
};


const ConfigVagasModal = ({ config, horarios, onClose, onSave }) => {
    const [form, setForm] = useState({ tipo: 'data', data: '', horario_id: '', limite: 3 });
    const [loading, setLoading] = useState(false);
    const [erro, setErro] = useState('');
    useEffect(() => {
        if (config) {
            setForm({
                tipo: config.data ? 'data' : 'geral',
                data: config.data ? new Date(config.data).toISOString().split('T')[0] : '',
                horario_id: config.horario_id || (horarios.length > 0 ? horarios[0].id : ''),
                limite: config.limite || 3,
            });
        } else if (horarios.length > 0) {
            setForm(prev => ({ ...prev, tipo: 'data', data: '', limite: 3, horario_id: horarios[0].id }));
        }
        setErro('');
    }, [config, horarios]);

    // Validação duplicidade e limite mínimo
    const validar = () => {
        if (!form.horario_id) return 'Selecione um horário.';
        if (form.tipo === 'data' && !form.data) return 'Informe a data.';
        if (parseInt(form.limite) < 1) return 'O limite mínimo é 1.';
        // Duplicidade: data + horario_id + grupo_id
        const dataVal = form.tipo === 'data' ? form.data : null;
        const jaExiste = window.configuracoesVagas?.some(c => {
            return (
                c.id !== config?.id &&
                c.horario_id === form.horario_id &&
                (c.data ? new Date(c.data).toISOString().split('T')[0] : null) === dataVal
            );
        });
        if (jaExiste) return 'Já existe uma configuração para essa data e horário.';
        return '';
    };

    // Expor configs para validação
    useEffect(() => {
        window.configuracoesVagas = horarios.length ? [] : [];
    }, [horarios]);

    useEffect(() => {
        window.configuracoesVagas = window.configuracoesVagas || [];
    }, []);

    const handleChange = (e) => {
        let value = e.target.value;
        setForm({ ...form, [e.target.name]: value });
        setErro('');
    };

    const handleTipoChange = (tipo) => {
        setForm(f => ({ ...f, tipo, data: tipo === 'data' ? f.data : '' }));
        setErro('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const erroValidacao = validar();
        if (erroValidacao) {
            setErro(erroValidacao);
            return;
        }
        setLoading(true);
        await onSave({ ...config, ...form, data: form.tipo === 'data' ? form.data : null });
        setLoading(false);
    };

    // Preencher configs para validação
    useEffect(() => {
        window.configuracoesVagas = window.configuracoesVagas || [];
        window.configuracoesVagas = window.configuracoesVagas.concat(window.configuracoesVagas.length === 0 ? [] : []);
    }, []);

    return (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex justify-center items-center z-50 p-4" aria-modal="true" role="dialog">
            <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-lg">
                <h2 className="text-2xl font-bold mb-6">{config?.id ? 'Editar Configuração' : 'Adicionar Configuração'}</h2>
                <form onSubmit={handleSubmit} className="space-y-4" aria-label="Formulário de configuração de vagas">
                    <div className="flex gap-4 mb-2">
                        <button type="button" onClick={() => handleTipoChange('data')} className={`px-4 py-2 rounded-lg font-semibold border ${form.tipo === 'data' ? 'bg-indigo-600 text-white border-indigo-600' : 'bg-gray-100 text-gray-700 border-gray-300'}`}>Data específica</button>
                        <button type="button" onClick={() => handleTipoChange('geral')} className={`px-4 py-2 rounded-lg font-semibold border ${form.tipo === 'geral' ? 'bg-indigo-600 text-white border-indigo-600' : 'bg-gray-100 text-gray-700 border-gray-300'}`}>Horário geral</button>
                    </div>
                    {form.tipo === 'data' && (
                        <div>
                            <label htmlFor="data" className="block text-sm font-medium">Data</label>
                            <input type="date" name="data" id="data" value={form.data} onChange={handleChange} className="mt-1 w-full p-2 border rounded-md" required aria-label="Data da configuração" disabled={loading} />
                        </div>
                    )}
                    <div>
                        <label htmlFor="horario_id" className="block text-sm font-medium">Horário</label>
                        <select name="horario_id" id="horario_id" value={form.horario_id} onChange={handleChange} className="mt-1 w-full p-2 border rounded-md bg-white" required aria-label="Horário" disabled={loading}>
                            {horarios.map(h => <option key={h.id} value={h.id}>{h.hora} - {h.rotulo}</option>)}
                        </select>
                    </div>
                    <div>
                        <label htmlFor="limite" className="block text-sm font-medium">Nº de Vagas</label>
                        <input type="number" name="limite" id="limite" value={form.limite} onChange={handleChange} className="mt-1 w-full p-2 border rounded-md" min="1" required aria-label="Número de vagas" disabled={loading} />
                    </div>
                    {erro && <div className="text-red-500 text-sm mt-2">{erro}</div>}
                    <div className="flex justify-end gap-4 pt-4">
                        <button type="button" onClick={onClose} className="px-5 py-2 bg-gray-200 rounded-lg" aria-label="Cancelar" disabled={loading}>Cancelar</button>
                        <button type="submit" className="px-5 py-2 bg-blue-600 text-white rounded-lg" disabled={loading}>{loading ? 'Salvando...' : 'Salvar'}</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

// --- Sub-componente: Aba para Gerir Períodos ---
const TabGerirPeriodos = ({ periodos, onEdit, onDelete, grupo }) => {
    // Status do período de preenchimento
    const getStatus = (inicio, fim) => {
        const hoje = new Date(); hoje.setHours(0, 0, 0, 0); const dataInicio = new Date(inicio); const dataFim = new Date(fim);
        if (hoje >= dataInicio && hoje <= dataFim) return <span className="px-2 py-1 text-xs font-semibold text-green-800 bg-green-200 rounded-full" title="Preenchimento aberto">Aberto</span>;
        if (hoje < dataInicio) return <span className="px-2 py-1 text-xs font-semibold text-blue-800 bg-blue-200 rounded-full" title="Preenchimento futuro">Futuro</span>;
        return <span className="px-2 py-1 text-xs font-semibold text-gray-800 bg-gray-200 rounded-full" title="Preenchimento encerrado">Encerrado</span>;
    };
    const formatarData = (data) => {
        if (!data) return <span className="text-gray-400 italic">Indefinido</span>;
        const d = new Date(data);
        if (isNaN(d.getTime())) return <span className="text-gray-400 italic">Indefinido</span>;
        const dia = String(d.getUTCDate()).padStart(2, '0');
        const mes = String(d.getUTCMonth() + 1).padStart(2, '0');
        const ano = d.getUTCFullYear();
        return `${dia}/${mes}/${ano}`;
    };
    // Lista de cores para coroinha (mesma do modal)
    const coresPadrao = [
        { nome: 'Branco', valor: '#FFFFFF' },
        { nome: 'Verde', valor: '#008000' },
        { nome: 'Vermelho', valor: '#FF0000' },
        { nome: 'Roxo', valor: '#800080' },
        { nome: 'Preto', valor: '#000000' },
        { nome: 'Roseo', valor: '#FFC0CB' },
    ];
    const isCoroinhas = grupo?.tipo?.toLowerCase() === 'coroinhas';
    return (
        <div>
            <div className="flex justify-between items-center mb-4">
                <h3 className="text-xl font-bold text-gray-700">Períodos de Preenchimento e Geração de Escala</h3>
                <button onClick={() => onEdit(null)} className="px-4 py-2 bg-indigo-600 text-white text-sm rounded-lg shadow-md hover:bg-indigo-700">+ Adicionar Período</button>
            </div>
            <div className="bg-white shadow-md rounded-lg overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Mês de Referência</th>
                            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Início Preenchimento</th>
                            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fim Preenchimento</th>
                            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Início Geração Escala</th>
                            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fim Geração Escala</th>
                            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                            {isCoroinhas && (
                                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cor Ombreira</th>
                            )}
                            <th className="px-4 py-2"></th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {periodos.map(p => (
                            <tr key={p.id} className={(() => {
                                // Destaca linha se geração de escala está aberta
                                const hoje = new Date(); hoje.setHours(0,0,0,0);
                                const ini = p.data_inicio_escala ? new Date(p.data_inicio_escala) : null;
                                const fim = p.data_fim_escala ? new Date(p.data_fim_escala) : null;
                                if (ini && fim && hoje >= ini && hoje <= fim) return 'bg-indigo-50';
                                return '';
                            })()}>
                                <td className="px-4 py-2 font-bold text-gray-800">{p.mes_referencia}</td>
                                <td className="px-4 py-2">{formatarData(p.data_inicio)}</td>
                                <td className="px-4 py-2">{formatarData(p.data_fim)}</td>
                                <td className="px-4 py-2">{formatarData(p.data_inicio_escala)}</td>
                                <td className="px-4 py-2">{formatarData(p.data_fim_escala)}</td>
                                <td className="px-4 py-2">{getStatus(p.data_inicio, p.data_fim)}</td>
                                {isCoroinhas && (
                                    <td className="px-4 py-2">
                                        {p.cor_ombreira_padrao ? (
                                            <span className="flex items-center gap-2">
                                                <span
                                                    className="w-5 h-5 rounded-full border border-gray-300 inline-block"
                                                    style={{ backgroundColor: p.cor_ombreira_padrao }}
                                                    title={
                                                        coresPadrao.find(c => c.valor === p.cor_ombreira_padrao)?.nome || p.cor_ombreira_padrao
                                                    }
                                                ></span>
                                                <span>
                                                    {coresPadrao.find(c => c.valor === p.cor_ombreira_padrao)?.nome || p.cor_ombreira_padrao}
                                                </span>
                                            </span>
                                        ) : (
                                            <span className="text-gray-400 italic">Não definida</span>
                                        )}
                                    </td>
                                )}
                                <td className="px-4 py-2 flex gap-2">
                                    <button onClick={() => onEdit({ ...p, grupo })} className="text-yellow-600 hover:text-yellow-800 text-sm">Editar</button>
                                    <button onClick={() => onDelete(p.id)} className="text-red-600 hover:text-red-800 text-sm">Excluir</button>
                                </td>
                            </tr>
                        ))}
                        {periodos.length === 0 && (
                            <tr>
                                <td colSpan={isCoroinhas ? 8 : 7} className="px-4 py-6 text-center text-gray-400">Nenhum período cadastrado.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};


const TabVerDisponibilidades = ({ horarios, submissoes, todosUsuarios, user }) => {
    // Filtra horários apenas do grupo do usuário logado, removendo horários inativos (ativo:false)
    const horariosFiltrados = useMemo(() => {
        if (!user?.grupo_id) return [];
        return Object.values(horarios).flat().filter(h => h.grupo_id === user.grupo_id && h.ativo !== false);
    }, [horarios, user]);

    // Filtra submissões apenas dos horários válidos do grupo
    const horarioIdsGrupo = useMemo(() => horariosFiltrados.map(h => h.id), [horariosFiltrados]);
    // Filtra submissões só de usuários do grupo (considerando usuario_id ou user_id)
    const usuarioIdsGrupo = useMemo(() => todosUsuarios.map(u => u.id), [todosUsuarios]);
    const submissoesFiltradas = useMemo(() => {
        return submissoes.filter(s => {
            const id = s.usuario_id ?? s.user_id;
            return horarioIdsGrupo.includes(s.horario_id) && usuarioIdsGrupo.includes(id);
        });
    }, [submissoes, horarioIdsGrupo, usuarioIdsGrupo]);

    const disponibilidadePorHorario = useMemo(() => {
        const mapa = {};
        horariosFiltrados.forEach(horario => { 
            mapa[horario.id] = []; 
        });
        submissoesFiltradas.forEach((submissao) => {
            const { horario_id, usuario_nome, usuario_sobrenome } = submissao;
            const nomeCompleto = `${usuario_nome || ''} ${usuario_sobrenome || ''}`.trim();
            if (mapa[horario_id] && !mapa[horario_id].includes(nomeCompleto)) {
                mapa[horario_id].push(nomeCompleto);
            }
        });
        return mapa;
    }, [horariosFiltrados, submissoesFiltradas]);

    // Renderização dos horários filtrados por grupo, agrupados por dia (corrigido para pegar o campo correto)
    const horariosPorDia = useMemo(() => {
        const mapa = {};
        horariosFiltrados.forEach(h => {
            const dia = h.dia || h.weekday || h.day || 'Outro';
            if (!mapa[dia]) mapa[dia] = [];
            mapa[dia].push(h);
        });
        return mapa;
    }, [horariosFiltrados]);

    // Calcula estatísticas gerais e listas de usuários
    const { estatisticas, usuariosEscaladosList, usuariosAEscalarList } = useMemo(() => {
        const usuariosComSubmissao = new Set();
        submissoesFiltradas.forEach((submissao) => {
            const id = submissao.usuario_id ?? submissao.user_id;
            if (id) {
                usuariosComSubmissao.add(id);
            }
        });
        // Lista de usuários escalados (do grupo, sem duplicidade)
        const usuariosEscaladosList = todosUsuarios.filter(u => usuariosComSubmissao.has(u.id)).map(u => `${u.name || ''} ${u.lastname || ''}`.trim()).sort();
        // Lista de usuários a escalar (do grupo)
        const usuariosAEscalarList = todosUsuarios.filter(u => !usuariosComSubmissao.has(u.id)).map(u => `${u.name || ''} ${u.lastname || ''}`.trim()).sort();
        const usuariosEscalados = usuariosEscaladosList.length;
        const totalUsuarios = todosUsuarios ? todosUsuarios.length : usuariosEscalados;
        const usuariosAEscalar = usuariosAEscalarList.length;
        const totalHorarios = horariosFiltrados.length;
        const estatisticas = {
            totalUsuarios,
            totalHorarios,
            usuariosEscalados,
            usuariosAEscalar
        };
        return {
            estatisticas,
            usuariosEscaladosList,
            usuariosAEscalarList
        };
    }, [horariosFiltrados, submissoesFiltradas, todosUsuarios]);

    // Define se as listas devem iniciar expandidas (false se há muitos usuários)
    const iniciarExpandido = useMemo(() => {
        const totalUsuarios = (usuariosEscaladosList.length + usuariosAEscalarList.length);
        return totalUsuarios <= 10; // Inicia expandido apenas se há 10 ou menos usuários no total
    }, [usuariosEscaladosList.length, usuariosAEscalarList.length]);

    const [expandidoEscalados, setExpandidoEscalados] = useState(iniciarExpandido);
    const [expandidoAEscalar, setExpandidoAEscalar] = useState(iniciarExpandido);

    // Atualiza o estado das listas quando os dados mudam
    useEffect(() => {
        setExpandidoEscalados(iniciarExpandido);
        setExpandidoAEscalar(iniciarExpandido);
    }, [iniciarExpandido]);

    return (
        <div className="space-y-8">
            {/* Área de estatísticas gerais */}
            <div className="bg-white p-6 rounded-lg shadow-md border">
                <h3 className="text-xl font-bold text-gray-700 mb-4">Resumo Geral</h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <div className="text-center p-4 bg-blue-50 rounded-lg">
                        <div className="text-2xl font-bold text-blue-600">{estatisticas.totalUsuarios}</div>
                        <div className="text-sm text-gray-600">Total de Usuários</div>
                    </div>
                    <div className="text-center p-4 bg-green-50 rounded-lg">
                        <div className="text-2xl font-bold text-green-600">{estatisticas.usuariosEscalados}</div>
                        <div className="text-sm text-gray-600">Usuários Escalados</div>
                    </div>
                    <div className="text-center p-4 bg-yellow-50 rounded-lg">
                        <div className="text-2xl font-bold text-yellow-600">{estatisticas.usuariosAEscalar}</div>
                        <div className="text-sm text-gray-600">Não Preencheram</div>
                    </div>
                    <div className="text-center p-4 bg-purple-50 rounded-lg">
                        <div className="text-2xl font-bold text-purple-600">{estatisticas.totalHorarios}</div>
                        <div className="text-sm text-gray-600">Total de Horários</div>
                    </div>
                </div>
            </div>

            {/* Listas de Usuários Escalados e A Escalar */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Usuários Escalados */}
                <div className="bg-green-50 p-6 rounded-lg shadow-md border border-green-200">
                    <div 
                        className="flex items-center justify-between cursor-pointer"
                        onClick={() => setExpandidoEscalados(!expandidoEscalados)}
                    >
                        <h4 className="text-lg font-bold text-green-700 mb-4 flex items-center">
                            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" 
                                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            Usuários Escalados ({usuariosEscaladosList.length})
                        </h4>
                        <button className="text-green-600 hover:text-green-800 transition-colors">
                            <svg 
                                className={`w-5 h-5 transition-transform ${expandidoEscalados ? 'rotate-180' : ''}`} 
                                fill="none" 
                                stroke="currentColor" 
                                viewBox="0 0 24 24"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                            </svg>
                        </button>
                    </div>
                    <div className="text-sm text-green-600 mb-3">
                        Usuários que já preencheram seus horários
                        {!expandidoEscalados && usuariosEscaladosList.length > 0 && (
                            <span className="ml-2 text-xs bg-green-200 px-2 py-1 rounded">
                                Clique para ver lista
                            </span>
                        )}
                    </div>
                    {expandidoEscalados && (
                        <>
                            {usuariosEscaladosList.length > 0 ? (
                                <ul className="space-y-1 max-h-60 overflow-y-auto">
                                    {usuariosEscaladosList.map((name, index) => (
                                        <li key={index} className="text-green-800 bg-green-100 px-3 py-1 rounded-lg text-sm">
                                            {name}
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <p className="text-green-600 italic text-sm">Nenhum usuário preencheu horários ainda</p>
                            )}
                        </>
                    )}
                </div>

                {/* Usuários A Escalar */}
                <div className="bg-yellow-50 p-6 rounded-lg shadow-md border border-yellow-200">
                    <div 
                        className="flex items-center justify-between cursor-pointer"
                        onClick={() => setExpandidoAEscalar(!expandidoAEscalar)}
                    >
                        <h4 className="text-lg font-bold text-yellow-700 mb-4 flex items-center">
                            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" 
                                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            Não Preencheram Escala ({usuariosAEscalarList.length})
                        </h4>
                        <button className="text-yellow-600 hover:text-yellow-800 transition-colors">
                            <svg 
                                className={`w-5 h-5 transition-transform ${expandidoAEscalar ? 'rotate-180' : ''}`} 
                                fill="none" 
                                stroke="currentColor" 
                                viewBox="0 0 24 24"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                            </svg>
                        </button>
                    </div>
                    <div className="text-sm text-yellow-600 mb-3">
                        Usuários que ainda não preencheram a escala de horários
                        {!expandidoAEscalar && usuariosAEscalarList.length > 0 && (
                            <span className="ml-2 text-xs bg-yellow-200 px-2 py-1 rounded">
                                Clique para ver lista
                            </span>
                        )}
                    </div>
                    {expandidoAEscalar && (
                        <>
                            {usuariosAEscalarList.length > 0 ? (
                                <ul className="space-y-1 max-h-60 overflow-y-auto">
                                    {usuariosAEscalarList.map((name, index) => (
                                        <li key={index} className="text-yellow-800 bg-yellow-100 px-3 py-1 rounded-lg text-sm">
                                            {name}
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <p className="text-yellow-600 italic text-sm">Todos os usuários já preencheram a escala de horários</p>
                            )}
                        </>
                    )}
                </div>
            </div>

            {/* Área de disponibilidades por horário */}
            <div>
                <h3 className="text-xl font-bold text-gray-700 mb-4">Disponibilidade por Dia da Semana</h3>
                <div className="space-y-10">
                    {Object.keys(horariosPorDia).length > 0 ? (
                        Object.entries(horariosPorDia).map(([dia, lista], idx) => (
                            <div key={dia} className="bg-white p-6 rounded-xl shadow border-t-4 border-indigo-300">
                                <h4 className="font-semibold capitalize text-xl text-indigo-700 mb-5 tracking-wide">{dia.replace('Outro', '').trim()}</h4>
                                <ul className="space-y-3">
                                    {lista.map(h => (
                                        <li key={h.id}>
                                            <span className="font-bold text-lg">{h.hora}{h.rotulo ? ` - ${h.rotulo}` : ''}</span>
                                            <div className="pl-3 mt-1">
                                                {disponibilidadePorHorario[h.id]?.length > 0 ? (
                                                    <ul className="list-disc list-inside text-sm text-gray-600">
                                                        {disponibilidadePorHorario[h.id].map((name, index) => <li key={index}>{name}</li>)}
                                                    </ul>
                                                ) : <span className="text-sm text-gray-400 italic">Ninguém disponível</span>}
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))
                    ) : (
                        <p className="text-center text-gray-500 py-4">Não há horários fixos cadastrados para exibir.</p>
                    )}
                </div>
            </div>
        </div>
    );
};


// --- Sub-componente: Aba para Configurar Vagas ---
const TabConfigVagas = ({ horarios, onEdit, onDelete, configuracoes }) => {
    const formatarData = (data) => {
        if (!data) return '';
        const d = new Date(data);
        if (isNaN(d.getTime())) return '';
        const dia = String(d.getUTCDate()).padStart(2, '0');
        const mes = String(d.getUTCMonth() + 1).padStart(2, '0');
        const ano = d.getUTCFullYear();
        return `${dia}/${mes}/${ano}`;
    };

    return (
        <div className="space-y-8"><div><h2 className="text-2xl font-bold text-gray-700">Configurar Vagas</h2><p className="text-gray-600 mt-1">Defina um limite de membros diferente do padrão para celebrações específicas.</p></div><div className="text-right"><button onClick={() => onEdit(null)} className="px-5 py-2 bg-indigo-600 text-white rounded-lg shadow-sm hover:bg-indigo-700">+ Adicionar Configuração</button></div><div className="mt-8"><h3 className="font-semibold text-lg text-slate-800 mb-2">Configurações Salvas</h3><div className="bg-white shadow-md rounded-lg"><ul className="divide-y divide-gray-200">{configuracoes.length > 0 ? configuracoes.map(c => (<li key={c.id} className="p-4 flex justify-between items-center"><div><p className="font-bold text-gray-800">{formatarData(c.data)} - {horarios.find(h => h.id === c.horario_id)?.rotulo || 'inválido'}</p><p className="text-sm text-gray-600">Limite: <span className="font-bold">{c.limite}</span></p></div><div className="flex gap-4"><button onClick={() => onEdit(c)} className="text-yellow-600 hover:text-yellow-800 text-sm font-medium">Editar</button><button onClick={() => onDelete(c.id)} className="text-red-500 hover:text-red-700 text-sm font-medium">Apagar</button></div></li>)) : (<li className="p-4 text-center text-gray-500">Nenhuma configuração específica adicionada.</li>)}</ul></div></div></div>
    );
};

const ModalExclusao = ({ onConfirm, onCancel, loading, type }) => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4" aria-modal="true" role="dialog">
        <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-6 animate-fade-in-scale">
            <h2 className="text-xl font-bold text-slate-800 mb-4">Confirmar Exclusão</h2>
            <p className="text-slate-600">
                {type === 'periodo' 
                    ? 'Tem a certeza que deseja excluir este período?' 
                    : 'Tem a certeza que deseja excluir esta configuração?'}
            </p>
            <div className="mt-6 flex justify-end gap-3">
                <button onClick={onCancel} className="px-4 py-2 bg-slate-200 text-slate-800 rounded-lg hover:bg-slate-300 font-semibold" disabled={loading}>Cancelar</button>
                <button onClick={onConfirm} className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 font-semibold" disabled={loading}>{loading ? 'Excluindo...' : 'Excluir'}</button>
            </div>
        </div>
    </div>
);

export default function GerenciadorEscalas({ grupo, usuarioPainel, token }) {
    const [innerTab, setInnerTab] = useState('disponibilidades');
    const [submissoes, setSubmissoes] = useState([]);
    const [horarios, setHorarios] = useState({});
    const [periodos, setPeriodos] = useState([]);
    const [configuracoes, setConfiguracoes] = useState([]);
    const [todosUsuarios, setTodosUsuarios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [periodoModalOpen, setPeriodoModalOpen] = useState(false);
    const [configModalOpen, setConfigModalOpen] = useState(false);
    const [editingItem, setEditingItem] = useState(null);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null); // { type, id }
    const [loadingDelete, setLoadingDelete] = useState(false);

    const fetchData = useCallback(async (isBackground = false) => {
        if (!isBackground) setLoading(true);
        setError(null);
        try {
            // Verifica se os dados necessários estão presentes
            if (!grupo?.paroquia_id || !grupo?.comunidade_id || !grupo?.grupo_id) {
                setError("Dados do grupo estão incompletos. Não é possível carregar os dados da gestão.");
                if (!isBackground) setLoading(false);
                return;
            }
            // Busca os períodos primeiro para extrair o intervalo de geração mais recente
            const periodosRes = await api.get(`/admin/periodos/grupo/${grupo.grupo_id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const fetchedPeriodos = periodosRes.data || [];
            setPeriodos(fetchedPeriodos);

            // Determina o período de geração mais recente: prioriza data_inicio_escala/data_fim_escala
            const periodoMaisRecente = (fetchedPeriodos || []).slice().sort((a, b) => {
                // usa data_inicio_escala, senão data_inicio, senão mes_referencia
                const aKey = a.data_inicio_escala || a.data_inicio || a.mes_referencia || '';
                const bKey = b.data_inicio_escala || b.data_inicio || b.mes_referencia || '';
                const aDate = aKey ? new Date(aKey) : new Date(0);
                const bDate = bKey ? new Date(bKey) : new Date(0);
                return bDate - aDate;
            })[0];

            let periodo_inicio = null;
            let periodo_fim = null;
            if (periodoMaisRecente) {
                periodo_inicio = periodoMaisRecente.data_inicio_escala || periodoMaisRecente.data_inicio || null;
                periodo_fim = periodoMaisRecente.data_fim_escala || periodoMaisRecente.data_fim || null;
            }

            // Agora busca os outros recursos; para submissões, inclui filtro por período de geração (se disponível)
            const [horariosRes, submissoesRes, configRes, usuariosRes] = await Promise.all([
                api.get(`/horarios/${grupo.paroquia.toLowerCase().replace(/\s+/g, '-')}/${grupo.comunidade.toLowerCase().replace(/\s+/g, '-')}/${grupo.tipo.toLowerCase().replace(/\s+/g, '-')}`, {
                    headers: { Authorization: `Bearer ${token}` }
                }),
                api.get('/admin/escalas/submissoes', {
                    params: Object.assign({ grupoId: grupo.grupo_id }, periodo_inicio ? { periodo_inicio: periodo_inicio } : {}, periodo_fim ? { periodo_fim: periodo_fim } : {}),
                    headers: { Authorization: `Bearer ${token}` }
                }),
                api.get('/admin/configuracoes-limite', {
                    params: { paroquiaId: grupo.paroquia_id, comunidadeId: grupo.comunidade_id, grupoId: grupo.grupo_id },
                    headers: { Authorization: `Bearer ${token}` }
                }),
                api.get(`/usuarios/grupo/${grupo.grupo_id}`, {
                    headers: { Authorization: `Bearer ${token}` }
                })
            ]);
            setHorarios(horariosRes.data.horarios || {});
            setSubmissoes(submissoesRes.data || []);
            setConfiguracoes(configRes.data || []);
            setTodosUsuarios(usuariosRes.data || []);
        } catch (err) {
            if (err.response?.status === 401) setError('Sessão expirada. Faça login novamente.');
            else {
                setError("Falha ao carregar os dados. Verifique a sua ligação e tente novamente.");
            }
        } finally {
            if (!isBackground) setLoading(false);
        }
    }, [grupo, token]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    // Funções de salvar usam grupo recebido via props
    const handleSavePeriodo = async (data) => {
        const payload = { ...data, paroquia_id: grupo.paroquia_id, comunidade_id: grupo.comunidade_id, grupo_id: grupo.grupo_id };
        if (!payload.data_inicio_escala) delete payload.data_inicio_escala;
        if (!payload.data_fim_escala) delete payload.data_fim_escala;
        try {
            let savedPeriodo;
            if (payload.id) {
                const res = await api.put(`/admin/periodos/${payload.id}`, payload, { headers: { Authorization: `Bearer ${token}` } });
                savedPeriodo = res.data;
                setPeriodos(prev => prev.map(p => p.id === payload.id ? { ...p, ...savedPeriodo } : p));
            } else {
                const res = await api.post('/admin/periodos', payload, { headers: { Authorization: `Bearer ${token}` } });
                savedPeriodo = res.data;
                setPeriodos(prev => [savedPeriodo, ...prev]);
            }
            setPeriodoModalOpen(false);
            toast.success('Período salvo com sucesso!');
            fetchData(true); 
        } catch (error) {
            let msg = 'Falha ao salvar.';
            if (error.response?.data?.error) msg = error.response.data.error;
            toast.error(msg);
        }
    };

    const handleSaveConfig = async (data) => {
        const payload = { ...data, paroquia_id: grupo.paroquia_id, comunidade_id: grupo.comunidade_id, grupo_id: grupo.grupo_id };
        try {
            let savedConfig;
            if (payload.id) {
                const res = await api.put(`/admin/configuracoes-limite/${payload.id}`, payload, { headers: { Authorization: `Bearer ${token}` } });
                savedConfig = res.data;
                setConfiguracoes(prev => prev.map(c => c.id === payload.id ? { ...c, ...savedConfig } : c));
            } else {
                const res = await api.post('/admin/configuracoes-limite', payload, { headers: { Authorization: `Bearer ${token}` } });
                savedConfig = res.data;
                setConfiguracoes(prev => [savedConfig, ...prev]);
            }
            setConfigModalOpen(false);
            toast.success('Configuração salva com sucesso!');
            fetchData(true); 
        } catch (error) {
            toast.error('Falha ao salvar configuração.');
        }
    };

    const handleDelete = (type, id) => {
        setItemToDelete({ type, id });
        setDeleteModalOpen(true);
    };

    const confirmDelete = async () => {
        if (!itemToDelete) return;
        const { type, id } = itemToDelete;
        setLoadingDelete(true);
        try {
            if (type === 'periodo') {
                await api.delete(`/admin/periodos/${id}`, { headers: { Authorization: `Bearer ${token}` } });
                setPeriodos(prev => prev.filter(p => p.id !== id));
            }
            if (type === 'config') {
                await api.delete(`/admin/configuracoes-limite/${id}`, { headers: { Authorization: `Bearer ${token}` } });
                setConfiguracoes(prev => prev.filter(c => c.id !== id));
            }
            toast.success('Excluído com sucesso!');
            setDeleteModalOpen(false);
            setItemToDelete(null);
            fetchData(true);
        } catch (error) {
            let msg = 'Falha ao excluir.';
            if (error.response?.data?.error) msg = error.response.data.error;
            toast.error(msg);
        } finally {
            setLoadingDelete(false);
        }
    };

    if (loading && periodos.length === 0 && submissoes.length === 0) return <p className="text-center p-8">A carregar...</p>;
    if (error) return <p className="text-center p-8 text-red-500">{error}</p>;

    return (
        <div>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <style>{`.animate-fade-in-scale { animation: fadeInScale 0.3s ease-out forwards; } @keyframes fadeInScale { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }`}</style>
            <div className="border-b border-gray-200 mb-6">
                <nav className="-mb-px flex space-x-6 overflow-x-auto">
                    <button onClick={() => setInnerTab('disponibilidades')} className={`py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${innerTab === 'disponibilidades' ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:border-gray-300'}`}>Ver Disponibilidades</button>
                    <button onClick={() => setInnerTab('periodos')} className={`py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${innerTab === 'periodos' ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:border-gray-300'}`}>Gerir Períodos</button>
                    <button onClick={() => setInnerTab('configVagas')} className={`py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${innerTab === 'configVagas' ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:border-gray-300'}`}>Configurar Vagas</button>
                </nav>
            </div>

            <div>
                {innerTab === 'disponibilidades' && <TabVerDisponibilidades horarios={horarios} submissoes={submissoes} todosUsuarios={todosUsuarios} user={usuarioPainel} periodos={periodos} />}
                {innerTab === 'periodos' && <TabGerirPeriodos periodos={periodos} onEdit={(p) => { setEditingItem(p); setPeriodoModalOpen(true); }} onDelete={(id) => handleDelete('periodo', id)} grupo={grupo} />}
                {innerTab === 'configVagas' && (() => {
                    const horariosFiltrados = Object.values(horarios).flat().filter(h => h.grupo_id === usuarioPainel?.grupo_id && h.ativo !== false);
                    return <TabConfigVagas horarios={horariosFiltrados} configuracoes={configuracoes} onEdit={(c) => { setEditingItem(c); setConfigModalOpen(true); }} onDelete={(id) => handleDelete('config', id)} user={usuarioPainel} />;
                })()}
            </div>

            {periodoModalOpen && <PeriodoModal periodo={editingItem} onClose={() => setPeriodoModalOpen(false)} onSave={handleSavePeriodo} grupo={editingItem?.grupo || grupo} />}
            {configModalOpen && (() => {
                const horariosFiltrados = Object.values(horarios).flat().filter(h => h.grupo_id === usuarioPainel?.grupo_id && h.ativo !== false);
                return <ConfigVagasModal config={editingItem} horarios={horariosFiltrados} onClose={() => setConfigModalOpen(false)} onSave={handleSaveConfig} />;
            })()}
            {deleteModalOpen && <ModalExclusao isOpen={deleteModalOpen} onConfirm={confirmDelete} onCancel={() => setDeleteModalOpen(false)} loading={loadingDelete} type={itemToDelete?.type} />}
        </div>
    );
}